e360.service('brandsApi', [
   'apiHelper',
   function (apiHelper) {
      return {
         get: function (id) {
            return apiHelper.get('brands/' + id);
         },
         create: function (brand) {
            return apiHelper.post('brands', brand);
         },
         update: function (brand) {
            brand = angular.copy(brand);
            delete brand.campaigns;

            return apiHelper.post('brands/' + brand.id, brand);
         },
         del: function (id) {
            return apiHelper.del('brands/' + id);
         }
      };
   }
]);
